import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { BaseServiceAccountResponseSchema } from './base';
export const ServiceAccountResponseSchema = BaseServiceAccountResponseSchema.extend({
    eAccountKeyByAdminKey: z.string(),
});
export class ServiceAccountResponseDto extends createZodDto(ServiceAccountResponseSchema) {
}
